/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

export const getByIdEarlyRequestRpc = {
  serviceName: 'com.hubspot.academy.catalog.rpc.noauth.LessonPublicChirpService',
  rpcName: 'getById',
  auth: 'external',
  fingerprint: 'z11n8HLLxEuxHZfTNxUi_19Ry1PAhX9Y',
  earlyRequest: true,
  na1Only: false,
  isStreaming: false
};
export const getByLanguageAndPagePathEarlyRequestRpc = {
  serviceName: 'com.hubspot.academy.catalog.rpc.noauth.LessonPublicChirpService',
  rpcName: 'getByLanguageAndPagePath',
  auth: 'external',
  fingerprint: 'XJKwyl0kS6GxHZfTNxUi_5wP6LXzGzX8',
  earlyRequest: true,
  na1Only: false,
  isStreaming: false
};